{
  "app_name": "Jinshuju UAT",
  "ios": {
    "CFBundleDisplayName": "Jinshuju UAT"
  }
}
